<template>
  <v-list subheader>
    <div v-for="(category, index) in categories" :key="category.id">
      <v-divider v-if="index > 0"></v-divider>

      <v-list-item>
        <v-list-item-icon>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on"> mdi-tag-multiple</v-icon>
            </template>
            <span>Tag-Kategorie</span>
          </v-tooltip>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>{{ category.description }}</v-list-item-title>
          <v-list-item-subtitle
            >Interncode: <code>{{ category.code }}</code
            >, Eventocode:
            <code>{{ category.eventoCode }}</code></v-list-item-subtitle
          >
        </v-list-item-content>
      </v-list-item>

      <template v-for="tag in category.items">
        <v-divider :key="tag.id + 'd'" inset></v-divider>
        <v-list-item :key="tag.id">
          <v-list-item-icon>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-bind="attrs" v-on="on" small right> mdi-tag</v-icon>
              </template>
              <span>Tag</span>
            </v-tooltip>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>{{ tag.description }}</v-list-item-title>
            <v-list-item-subtitle
              >Interncode: <code>{{ tag.code }}</code
              >, Eventocode:
              <code>{{ tag.eventoCode }}</code></v-list-item-subtitle
            >
          </v-list-item-content>
        </v-list-item>
      </template>
    </div>
  </v-list>
</template>

<script>
import { defineComponent } from "vue";
import { saveChildRoute } from "@/router/helper";

export default defineComponent({
  name: "PersonTags",
  props: {
    id: { type: String },
  },
  computed: {
    personId() {
      return Number.parseInt(this.id);
    },
  },
  data() {
    return {
      categories: [],
      loading: false,
    };
  },
  methods: {
    async getData() {
      if (this.personId) {
        this.loading = true;
        const data = await this.apiGet({
          resource: "person/tag",
          id: this.personId,
        });
        this.categories = data.categories;
        this.loading = false;
      }
    },
  },
  watch: {
    async id() {
      await this.getData();
    },
  },
  async created() {
    await this.getData();
  },
  beforeRouteUpdate(to, from, next) {
    saveChildRoute(to, next);
  },
});
</script>
